export default __webpack_public_path__ + "static/media/SLD2-B.777807fa.png";